<header>
    <div class="container-fluid anim-container">
        <div id="" class="row mx-auto">
            <div class="col text-kl-white text-center displayTxt-anim">          
                <h1 id="splitit" class="kl-display-1 txt1">
                   40.000
                </h1>
                <div class="fortysix">                       
                <img src="../../../../assets/images/forside_hero/dis-5.svg" alt="4 mio" class="dis-4">
                <img src="../../../../assets/images/forside_hero/dis-2.svg" alt="6 mio" class="dis-6">
                </div>
             </div> 
        </div> <!--row-->
        <div class="row text-center mx-auto">           
            <div class="col-md-6 col-lg-7 col-xl-6">
            </div>
            <div class="col-md-6 col-lg-4 col-xl-4 text-kl-white pad-top-4">
                <h3 class="sub swapTxt">Glade vindere</h3> 
                <h3 class="sub txt3 pt-0">Hver Måned</h3> 
            </div>
            <div class="col-lg-1 col-xl-2">
            </div>
        </div> <!--row-->
        <!--URGENCY COUNTEREN-->
        <!-- <div class="urgency">
            <h5>Køb inden mandag kl. 10</h5>
            <app-countdown-v2 [date]="saleStopDate"></app-countdown-v2>
        </div>  -->
            <h5 class="mx-auto text-kl-white text-center pad-top-3">Spil med fra 20 kr.</h5>   
            <div class="cta mx-auto text-kl-white text-center"><a (click)="showPage()" class="btn btn-kl-blue btn-lg">KØB LODDER</a></div>                             
    </div> <!--container-->
</header> 
